import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { ShoppingCart } from '../../api/shoppingCart';
import ShoppingCartAsideContentRow from './ShoppingCartAsideContentRow';

export interface ShoppingCartAsideContentProps extends StandardDivProps<ShoppingCartAsideContentClassKey> {
  cartContent: ShoppingCart['cartContent'];
}

export type ShoppingCartAsideContentClassKey = 'root';

const themeSettings = { name: 'ShoppingCartAsideContent' };
const useStyles = makeStyles(
  createStyles<ShoppingCartAsideContentClassKey, {}>({
    root: {},
  }),
  themeSettings,
);

const ShoppingCartAsideContent = React.forwardRef<HTMLDivElement, ShoppingCartAsideContentProps>(
  ({ cartContent, className, classes: pClasses }, ref) => {
    const classes = useStyles({ classes: pClasses });

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        {[...cartContent.subjects]
          .reverse()
          .filter((i) => typeof i.product !== 'string' && i.product.taxonomies?.includes('/catalogue'))
          .map((subject, idx) => (
            <ShoppingCartAsideContentRow key={idx.toString()} subject={subject} />
          ))}
      </div>
    );
  },
);

ShoppingCartAsideContent.displayName = 'ShoppingCartAsideContent';

export default withThemeProps(themeSettings)(ShoppingCartAsideContent);
